export function preparationError(error, operation = '') {
  const parts = [operation, error.message || 'تعذر إكمال الطلب.'];
  if (error.status) parts.push(`HTTP ${error.status}`);
  if (error.code) parts.push(`رمز الخطأ: ${error.code}`);
  if (error.requestId) parts.push(`رمز التتبع: ${error.requestId}`);
  return parts.filter(Boolean).join(' · ');
}
